if (!customElements.get('announcement-slider')) {
  class AnnouncementSlider extends HTMLElement {
    constructor() {
      super();
    }

    initSlider() {
      this.targetElement = this.querySelector('[js-slider]');

      if (!this.targetElement) return;

      this.options = {
        effect: 'fade',
        slidesPerView: 1,
        fadeEffect: {
          crossFade: true,
        },
      };

      if (this.hasAttribute('data-time-between-slides')) {
        this.options.loop = true;
        this.options.autoplay = {
          delay: Number(this.getAttribute('data-time-between-slides')),
        };
      }

      this.slider = new Swiper(this.targetElement, this.options);
    }

    setAnnouncementBarHeightVariable() {
      const section = this.closest('section');
      if (!section) return;
      const rect = section.getBoundingClientRect();
      document.documentElement.style.setProperty(
        '--announcement-bar-height',
        rect.height + 'px',
      );
      document.documentElement.style.setProperty(
        '--announcement-bar-offset',
        rect.height + 'px',
      );
    }

    connectedCallback() {
      this.setAnnouncementBarHeightVariable();

      window.setTimeout(() => {
        this.initSlider();
      }, 200);
    }
  }

  customElements.define('announcement-slider', AnnouncementSlider);
}
